import * as z from 'zod';
import * as ba from './base';
import { SCRIPT_SCHEMA } from '../scripting';
import { isComponentContext, assertVueComponent } from '../helpers';

export interface EmitActionArgs {
  event: string;
  value?: any;
  source?: string;
}

export class EmitAction extends ba.Action<EmitActionArgs, any> {
  static get manifest() {
    return {
      name: 'emit',
      schema: z.object({
        event: z.string(),
        value: z.any().optional(),
        source: z.string().optional(),
      }),
    };
  }

  async handle(event: ba.ActionEvent, args: EmitActionArgs) {
    assertVueComponent(event.component);

    if (args.source === 'root') {
      const app = (event.component as any).$app;
      if (app && app.events) {
        return app.events.emit(args.event, args.value);
      }
      event.component.$emit(args.event, args.value);
      return;
    }

    event.component.$emit(args.event, args.value);
  }
}
